import React from 'react'
import ContentLoader from 'react-content-loader'

const AccordionLoader = props => {
  return (
    <ContentLoader
      speed={2}
      width={"100%"}
      height={260}
      viewBox="0 0 100% 260"
      backgroundColor="#252525"
      foregroundColor="#cccccc"
      {...props}
    >
      <rect x="7%" y="6" rx="4" ry="4" width="93%" height="51" />
      <rect x="0" y="6" rx="4" ry="4" width="5%" height="51" />
      <rect x="7%" y="65" rx="4" ry="4" width="93%" height="51" />
      <rect x="0" y="65" rx="4" ry="4" width="5%" height="51" />
      <rect x="7%" y="125" rx="4" ry="4" width="93%" height="51" />
      <rect x="0" y="125" rx="4" ry="4" width="5%" height="51" />
    </ContentLoader>
  )
}

export default AccordionLoader